import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  products: [],
  filter: {
    text: '',
    minNights: null,
    maxNights: null,
    minPrice: null,
    maxPrice: null,
    categories: [],
    themes: [],
    sortBy: 'weRecommend',
    countries: [],
    page: 1,
    pageSize: 18,
    nightsArray: [],
    priceArray: [],
    tags: [],
  },
  available_tags: {},
  page: 1,
  pageSize: 18,
  totalCount: 0,
  title: 'Suche',
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
